import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {EliteFormManagerService} from '@features/elite-form/services/elite-form-manager.service';
import {Subject} from "rxjs";
import {BehaviorSubject} from "rxjs";
import {EliteFormServiceFactory} from "@features/elite-form/services/elite-form-service-factory.service";
import {EliteFormPageModel} from "@features/elite-form/models/elite-form-common-data-models";
import {PlatformDialog} from "@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models";
import {FormResponseViewService} from "@features/elite-form/services/form-response-view.service";


@Component({
    standalone: false,
    selector: 'app-elite-form-single-page-response',
  templateUrl: './elite-form-single-page-response.component.html',
  styleUrls: ['./elite-form-single-page-response.component.scss']
})
export class EliteFormSinglePageResponseComponent implements OnInit, OnDestroy {
  @Input() platformDialogs = [];
  @Input() platformDialog: PlatformDialog;
  @Input() pageModel: EliteFormPageModel;
  @Input() inputForm: FormGroup;
  @Input() itemId: string;
  @Input() totalPageCount: number;
  @Output() fieldValueChange = new EventEmitter();
  // FM-E-55: bubble the per-section Include signal up to the container, which owns the reload.
  @Output() sectionIncluded = new EventEmitter<void>();
  private unSubscribe$ = new Subject<void>();
  dialogFields$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  filteredPlatformDialogs: any;
  private eliteFormManagerService: EliteFormManagerService;
  isSaving: boolean = false;
  
  constructor(
    private eliteFormServiceFactory: EliteFormServiceFactory,
    private formResponseViewService: FormResponseViewService
  ) { }

  ngOnInit(): void {
    this.eliteFormManagerService = this.eliteFormServiceFactory.getEliteFormManagerService(this.pageModel.eliteFormId);
    
    this.formResponseViewService.getSavingStatus()
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe(isSaving => {
        this.isSaving = isSaving;
      });
  }
  
  onFieldValueChange(event){
    this.fieldValueChange.emit(event);
  }

  onSectionIncluded(){
    this.sectionIncluded.emit();
  }

  ngOnDestroy(){
    // this.dialogFields$.complete();
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
